<template>
  <ul class="flex-1 overflow-auto">
    <li v-if="!townsToModel.textSearchQuery.value">
      <label
        class="flex cursor-pointer items-center space-x-3 rounded-xl p-4 duration-200 hover:bg-gray-75 active:bg-gray-75"
      >
        <UiCheckbox
          :checked="townsToModel.isAllSelected.value"
          @change="
            $event.target.checked
              ? onSelect(props.townsTo)
              : onUnselect(props.townsTo)
          "
        />
        <span>{{ $t('search-form.arrival.all-regions') }}</span>
      </label>
    </li>

    <li
      v-for="town in townsToModel.filteredByTextSearchQueryTowns.value"
      :key="town.id"
    >
      <label
        class="flex cursor-pointer items-center space-x-3 rounded-xl p-4 duration-200 hover:bg-gray-75 active:bg-gray-75"
      >
        <UiCheckbox
          :checked="townsToModel.isTownSelected(town.id)"
          @change="
            $event.target.checked ? onTownsToUpdated(town) : onUnselect([town])
          "
        />
        <span>{{ town.name }}</span>
      </label>
    </li>
  </ul>
</template>

<script setup lang="ts">
  import { computed, onMounted } from 'vue';
  import { Tourflow } from '@aviata/platform-types';

  import { useTownsTo } from '@entities/towns-to';
  import { UiCheckbox } from '@shared/ui';

  const props = defineProps<{
    townsTo: Tourflow.TownTo[];
    initialTownsTo: Tourflow.TownTo[] | null;
  }>();

  const emit = defineEmits<{
    onTownsToChange: [towns: Tourflow.TownTo[] | null];
  }>();

  const townsToModel = useTownsTo(props.townsTo, props.initialTownsTo);

  const townsToFormSubmit = computed(() => townsToModel.getTownsToForSubmit());

  const onSelect = (towns: Tourflow.TownTo[]) => {
    townsToModel.onTownsToSelect(towns);
    emit('onTownsToChange', townsToFormSubmit.value);
  };

  const onUnselect = (towns: Tourflow.TownTo[]) => {
    townsToModel.onTownUnselect(towns);
    emit(
      'onTownsToChange',
      towns.length === props.townsTo.length ? null : townsToFormSubmit.value,
    );
  };

  const onTownsToUpdated = (town: Tourflow.TownTo) => {
    onSelect([...townsToModel.selectedTowns.value, town]);
  };

  onMounted(() => {
    emit('onTownsToChange', townsToFormSubmit.value);
  });
</script>
